export const FORM_CHANNEL = 'FORM_RENDERER_BROADCAST';

const channel = new BroadcastChannel(FORM_CHANNEL);

export const sendBroadcast = (type: string, payload?: any) => {
  console.log('sending broadcast message', type, payload)
  channel.postMessage({ type, payload, timestamp: Date.now() });
};

export const onBroadcast = (callback: (message: any) => void) => {
  const listener = (event: MessageEvent) => callback(event.data);
  channel.addEventListener('message', listener);
  return () => {
    channel.removeEventListener('message', listener);
  };
};